import LegalLayout from "@/components/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      eyebrow="Refund & returns"
      title="Refund Policy"
      lastUpdated="December 2025"
      testid="page-refund"
    >
      <h2 className="font-display font-bold text-2xl tracking-tight">Overview</h2>
      <p>
        Every copy of <em>The 12 Laws of Dating Dynamics</em> ordered directly through this site is personally signed by Manuel Santana. Because each book is signed-on-demand, we handle refunds carefully and case-by-case.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">30-day satisfaction window</h2>
      <p>
        You may request a refund within <strong>30 days of delivery</strong> if your book arrives damaged, defective, or never arrives. Refunds for buyer's remorse (you changed your mind) are accepted within the same window provided the book is returned in unread, resalable condition at your expense.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">How to request a refund</h2>
      <p>
        Email <a href="mailto:orders@12lawsbook.com" className="underline text-[#D92D20]">orders@12lawsbook.com</a> from the address used at checkout. Include your order number and the reason for the request. We respond within 2 business days.
      </p>
      <p>
        For damaged or defective copies, attach a photo of the issue. We'll typically replace it at no cost, no return required.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Shipping costs</h2>
      <p>
        Shipping fees are non-refundable unless the order arrived damaged or was lost in transit. Return shipping costs for buyer's-remorse refunds are the customer's responsibility.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Processing time</h2>
      <p>
        Approved refunds are issued to the original payment method within <strong>5–10 business days</strong> of receipt. Your bank may take additional time to post the refund.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Non-refundable items</h2>
      <p>
        Free digital downloads (e.g. the 12 Laws reference card) and items purchased outside this site (Amazon, retail bookstores, etc.) are governed by the policies of those sellers.
      </p>
    </LegalLayout>
  );
}
